export default [
    {
        "body": {
            "pantone": {
                "id": "18-1660 TCX",
                "name": "Tomato"
            },
            "srgb": "#d42737"
        },
        "ink": {
            "pantone": {
                "id": "17-1647 TCX",
                "name": "Dubarry"
            },
            "srgb": "#f06065"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "16-1343 TCX",
                "name": "Autumn Sunset"
            },
            "srgb": "#f48353"
        },
        "ink": {
            "pantone": {
                "id": "16-1360 TCX",
                "name": "Nectarine"
            },
            "srgb": "#f48459"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "13-0858 TCX",
                "name": "Vibrant Yellow"
            },
            "srgb": "#ffd82b"
        },
        "ink": {
            "pantone": {
                "id": "13-0850 TCX",
                "name": "Aspen Gold"
            },
            "srgb": "#ffd462"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "15-6340 TCX",
                "name": "Irish Green"
            },
            "srgb": "#42b777"
        },
        "ink": {
            "pantone": {
                "id": "14-6340 TCX",
                "name": "Spring Bouquet"
            },
            "srgb": "#6fc286"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "18-4930 TCX",
                "name": "Tropical Green"
            },
            "srgb": "#008586"
        },
        "ink": {
            "pantone": {
                "id": "18-5128 TCX",
                "name": "Blue Grass"
            },
            "srgb": "#007b7c"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "15-5416 TCX",
                "name": "Florida Keys"
            },
            "srgb": "#54bbaa"
        },
        "ink": {
            "pantone": {
                "id": "16-5425 TCX",
                "name": "Pool Green"
            },
            "srgb": "#00ac9d"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "18-4244 TCX",
                "name": "Directoire Blue"
            },
            "srgb": "#0062a2"
        },
        "ink": {
            "pantone": {
                "id": "19-4056 TCX",
                "name": "Blue Iolite"
            },
            "srgb": "#114c8a"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "2090 C",
                "name": ""
            },
            "srgb": "#663ab5"
        },
        "ink": {
            "pantone": {
                "id": "18-3737 TCX",
                "name": "Passion Flower"
            },
            "srgb": "#6d5897"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "15-3214 TCX",
                "name": "Orchid"
            },
            "srgb": "#d398c4"
        },
        "ink": {
            "pantone": {
                "id": "15-1920 TCX",
                "name": "Morning Glory"
            },
            "srgb": "#ef809b"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "19-4005 TCX",
                "name": "Stretch Limo"
            },
            "srgb": "#2b2c2f"
        },
        "ink": {
            "pantone": {
                "id": "19-4005 TCX",
                "name": "Stretch Limo"
            },
            "srgb": "#2b2c2f"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "14-4206 TCX",
                "name": "Pearl Blue"
            },
            "srgb": "#b0b6be"
        },
        "ink": {
            "pantone": {
                "id": "15-4101 TCX",
                "name": "High-rise"
            },
            "srgb": "#adb0b4"
        }
    },
    {
        "body": {
            "pantone": {
                "id": "11-4800 TCX",
                "name": "Blanc de Blanc"
            },
            "srgb": "#e5e7e6"
        },
        "ink": {
            "pantone": {
                "id": "11-4800 TCX",
                "name": "Blanc de Blanc"
            },
            "srgb": "#e5e7e6"
        }
    }
];
